import { useQuery } from "@tanstack/react-query";
import { ingestApi } from "../../../api";

export function useSearchLegislationWorks(searchTerm: string) {
  const term = searchTerm.trim();
  return useQuery({
    queryKey: ["searchLegislationWorks", term],
    queryFn: () => ingestApi.searchLegislationWorks({ search_term: term }),
    enabled: term.length >= 3,
  });
}
